<template>
    <div class="col-md-12">
        <div class="pt-3">
            <div class="row my-3">
                <div class="col-md-8">
                    <div class="h2">Drivers cost</div>
                    <div class="flash-message">
                        <FlashMessage :position="'top'"></FlashMessage>
                    </div>
                </div>
            </div>
            <div class="row my-3">
                <div class="col-12">
                    <div class="position-relative pagination-control table-hover">
                        <data-table
                            :columns="columns"
                            :url="tableUrl"
                            :per-page="perPage"
                            :order-dir="orderDir"
                            :meta="columns.meta"
                            :classes="classes"
                            :translate="translate"
                            :filters="filters"
                            :debounce-delay=1000
                            ref="table"
                        >
                            <div slot="filters" slot-scope="{ tableFilters, perPage }"></div>
                            <thead class="clickable-header bg-page" style="color: #ffffff;" slot="header" slot-scope="{ tableFilters }">
                            <tr>
                                <th @click="sort(column.id)" v-if="column.label!==''"
                                    v-for="column in columns">
                                    <span> {{ column.label }}  </span>
                                </th>
                            </tr>
                            </thead>
                            <tbody slot="body" slot-scope="{ data }">
                            <tr :key="item.id"
                                v-for="item in data">
                                <td :key="column.name"
                                    v-for="column in columns"
                                    class="laravel-vue-datatable-td border-0 text-left py-2 font-weight-normal"
                                >
                                    <data-table-cell
                                        :value="item"
                                        :name="column.name"
                                        :meta="column.meta"
                                        :comp="column.component"
                                        :classes="column.classes">
                                    </data-table-cell>

                                    <slot v-if="column.label === 'Company'">
                                        {{ item.companyName.name }}
                                    </slot>
                                    <slot v-if="column.id === 'price_doorstep'">
                                        <div
                                            style="max-width: 200px;"
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                            <input type="number"
                                                   required
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   placeholder=""
                                                   autocomplete="off"
                                                   v-model="item.price_doorstep">
                                        </div>
                                    </slot>
                                    <slot v-if="column.id === 'price_pickup'">
                                        <div
                                            style="max-width: 200px;"
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                            <input type="number"
                                                   required
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   placeholder=""
                                                   autocomplete="off"
                                                   v-model="item.price_pickup">
                                        </div>
                                    </slot>
                                    <slot v-if="column.id === 'price_in_house'">
                                        <div
                                            style="max-width: 200px;"
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                            <input type="number"
                                                   required
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   placeholder=""
                                                   autocomplete="off"
                                                   v-model="item.price_in_house">
                                        </div>
                                    </slot>
                                    <slot v-if="column.id === 'price_in_house_mounted'">
                                        <div
                                            style="max-width: 200px;"
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                            <input type="number"
                                                   required
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   placeholder=""
                                                   autocomplete="off"
                                                   v-model="item.price_in_house_mounted">
                                        </div>
                                    </slot>
                                    <slot v-if="column.id === 'price_depot'">
                                        <div
                                            style="max-width: 200px;"
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                            <input type="number"
                                                   required
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   placeholder=""
                                                   autocomplete="off"
                                                   v-model="item.price_depot">
                                        </div>
                                    </slot>
                                    <slot v-if="column.id === 'price_per_distance'">
                                        <div
                                            style="max-width: 200px;"
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                            <input type="number"
                                                   required
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   placeholder=""
                                                   autocomplete="off"
                                                   v-model="item.price_per_distance">
                                        </div>
                                    </slot>
                                    <slot v-if="column.id === 'price_per_volume'">
                                        <div
                                            style="max-width: 200px;"
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                            <input type="number"
                                                   required
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   placeholder=""
                                                   autocomplete="off"
                                                   v-model="item.price_per_volume">
                                        </div>
                                    </slot>
                                    <slot v-if="column.id === 'price_per_weight'">
                                        <div
                                            style="max-width: 200px;"
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                            <input type="number"
                                                   required
                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                   placeholder=""
                                                   autocomplete="off"
                                                   v-model="item.price_per_weight">
                                        </div>
                                    </slot>
                                </td>
                            </tr>
                            </tbody>

                            <div slot="pagination" slot-scope="{ links, meta }"
                                 class="d-flex justify-content-between align-items-center"
                            >
                                <div>
                                    <label class="pr-2">Per page:</label>
                                    <div class="d-inline-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                        <select class="form-control bg-white border-0 py-0 shadow-none " v-model="filters.length"
                                                style="width: 150px;">
                                            <option
                                                :key="index"
                                                :value="records"
                                                v-for="(records, index) in perPage">
                                                {{ records }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <pagination
                                    ref="pagination"
                                    :total-pages="meta.last_page"
                                    :current-page-prop="meta.current_page"
                                    v-if="meta && meta.last_page > 1"
                                ></pagination>
                            </div>
                        </data-table>
                        <div class="d-flex justify-content-end w-100 mt-3">
                            <button type="button" class="btn btn-success" @click="saveAll">Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="pt-3">
            <div class="row my-3">
                <div class="col-md-8">
                    <div class="h2">Apply costs to old trips</div>
                </div>
            </div>
            <div class="form-group">
                <div class="form-group row">
                    <div class="col-md-4">
                        <label><b>From</b></label>
                        <div class="form-group d-flex">
                            <div
                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2 mr-3 flex-1">
                                <date-picker v-model="applyCostFilter.from" required
                                             valueType="YYYY-MM-DD"
                                             input-class="border-0 py-0 shadow-none form-input"
                                             placeholder="dd/mm/yyyy"
                                             :lang="datePickerOptions.lang"
                                             format="DD/MM/YYYY"></date-picker>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <label><b>To</b></label>
                        <div class="form-group d-flex">
                            <div
                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2 mr-3 flex-1">
                                <date-picker v-model="applyCostFilter.to" required
                                             valueType="YYYY-MM-DD"
                                             input-class="border-0 py-0 shadow-none form-input"
                                             placeholder="dd/mm/yyyy"
                                             :lang="datePickerOptions.lang"
                                             format="DD/MM/YYYY"></date-picker>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <button type="submit" class="btn mt-3 btn-primary" @click="applyCosts">
                Apply
            </button>
        </div>

        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true">
        </loading>
    </div>
</template>

<script>
import 'vue-loading-overlay/dist/vue-loading.css';
import Loading from "vue-loading-overlay";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import datePickerOptionsMixin from "../mixins/datePickerOptionsMixin";
import moment from "moment/moment";
import Pagination from "./reusable/Pagination.vue";
import modalMixin from "../mixins/modalMixin";
import dataTablePaginationMixin from "../mixins/dataTablePaginationMixin";

export default {
    name: "CompanyNameCost",
    components: {Pagination, DatePicker, Loading},
    mixins: [datePickerOptionsMixin, modalMixin, dataTablePaginationMixin],
    props: {
        url: {type: String, required: true}
    },
    watch: {
        filters: {
            handler: function(newValue) {
                if (this.$refs.pagination) {
                    this.$refs.pagination.changePage('', 1);
                }
            },
            deep: true
        }
    },
    data() {
        return {
            isLoading: false,
            tableUrl: this.url,
            perPage: [25, 10, 50, 100],
            orderDir: 'desc',
            companiesList: [{name: 'All'}],
            columns: [
                {
                    label: 'Company',
                    id: 'companyName',
                    orderable: true,
                },
                {
                    label: '1 Mand',
                    id: 'price_doorstep',
                    orderable: true
                },
                {
                    label: '2 Mand',
                    id: 'price_in_house',
                    orderable: false,
                },
                {
                    label: 'Montering',
                    id: 'price_in_house_mounted',
                    orderable: false,
                },
                {
                    label: 'Depot',
                    id: 'price_depot',
                    orderable: false,
                },
                {
                    label: 'Afhentning',
                    id: 'price_pickup',
                    orderable: true
                },
                {
                    label: 'DKK/m3',
                    id: 'price_per_volume',
                    orderable: true,
                },
                {
                    label: 'DKK/kg',
                    id: 'price_per_weight',
                    orderable: true,
                },
                {
                    label: 'DKK/km',
                    id: 'price_per_distance',
                    orderable: true,
                },
            ],
            filters: {
                length: 25,
                column: 'id',
                dir: 'desc',
            },
            classes: {
                'table-container': {
                    'justify-center': true,
                    'w-full': true,
                    'flex': true,
                    'rounded-lg': true,
                    'mb-4': true,
                    'shadow-md': true,
                    'border': true,
                    'overflow-hidden': true
                },
                table: {
                    'text-left': true,
                    'w-full': true,
                    'border-collapse': true,
                    'table': true,
                    'table-striped': true,
                    'border': false,
                    'mb-0': true
                },
                't-head': {
                    'text-grey-dark': true,
                    'bg-black': true,
                    'border-grey-light': true,
                    'py-4': true,
                    'px-6': true,
                    'border': false,
                    'bg-white': true,
                },
                "t-body": {
                    'bg-grey-darkest': true,
                    'border-0': true,
                },
                "th": {
                    'border-left-0': true,
                    'border-right': true,
                    'border-bottom-0': true,
                    'border-top-0': true,
                    'shadow-sm': true,
                    'position-relative': true,
                    'font-weight-semi-bold': true,
                    'h6': true,
                    'text-left': true,

                },
                "td": {
                    'py-1': true,
                    'border-0': true,
                    'laravel-vue-datatable-td': false,
                }
            },
            translate: {
                nextButton: '',
                previousButton: '',
            },
            reportFilter: {
                from: '',
                to: '',
                company: ''
            },
            reportErrors: {
                from: '',
                to: '',
                company: ''
            },
            applyCostFilter: {
                from: '',
                to: '',
            }
        }
    },
    methods: {
        sort(key) {
            if (key) {
                this.columns.forEach((column) => {
                    if (column.id === key && column.orderable) {
                        this.filters.column = key;
                        this.filters.dir = this.filters.dir === 'asc' ? 'desc' : 'asc';
                    }
                });
            }
        },
        formatDate(date) {
            return moment(date).format('DD/MM/YYYY');
        },
        saveAll() {
            this.isLoading = true;
            axios.post(`/driver-cost/saveAll`, {data: this.$refs.table.tableData.data})
                .then((response) => {
                    this.flashMessage.success({
                        title: '',
                        message: 'Success',
                        time: 2000,
                        blockClass: 'flash-message'
                    });
                }).catch((error) => {
                this.flashMessage.error({
                    title: '',
                    message: error.response.data.message,
                    time: 2000,
                    blockClass: 'flash-message error'
                });
                console.log(error.response)
            }).finally(() => {
                this.isLoading = false;
            })
        },
        applyCosts() {
            if (!this.applyCostFilter.from || ! this.applyCostFilter.to) {
                return;
            }
            this.isLoading = true;
            axios.post(`/driver-cost/apply-costs`, {from: this.applyCostFilter.from, to: this.applyCostFilter.to})
                .then((response) => {
                    this.flashMessage.success({
                        title: '',
                        message: 'Success',
                        time: 2000,
                        blockClass: 'flash-message'
                    });
                    this.$set(this.applyCostFilter, 'from', '')
                    this.$set(this.applyCostFilter, 'to', '')
                }).catch((error) => {
                this.flashMessage.error({
                    title: '',
                    message: error.response.data.message,
                    time: 2000,
                    blockClass: 'flash-message error'
                });
                console.log(error.response)
            }).finally(() => {
                this.isLoading = false;
            })
        }
    },
}
</script>
<style scoped>
.custom-v-select {
    min-width: 200px;
}
</style>
